export default "__VITE_ASSET__DkVQ5Dil__"